module.exports = __webpack_public_path__ + "img/redes.399c52ab.png";